import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, LogIn } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

const MR = { fontFamily: 'Manrope, sans-serif' };

function LangToggle() {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex items-center rounded-full border border-border/40 bg-card/40 overflow-hidden h-7" data-testid="lang-toggle">
      {['en', 'es'].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          className={`px-2.5 h-full text-[11px] font-semibold tracking-wider uppercase transition-colors ${
            lang === l
              ? 'bg-primary/15 text-primary'
              : 'text-muted-foreground/60 hover:text-muted-foreground'
          }`}
          style={MR}
          data-testid={`lang-${l}`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}

export function MarketingHeader() {
  const { pathname } = useLocation();
  const { t } = useLanguage();
  const isBriefing = pathname === '/briefing';

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.06] bg-[hsl(220,15%,8%)]/80 backdrop-blur-xl">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="marketing-logo">
          <div className="w-9 h-9 rounded-lg bg-primary/10 border border-primary/20 flex items-center justify-center transition-colors group-hover:border-primary/40">
            <svg className="w-4 h-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-label="YBV logo"><line x1="12" y1="2" x2="12" y2="22"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
          </div>
          <span className="text-[15px] font-semibold text-foreground tracking-tight" style={MR}>
            YBV
          </span>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-5">
          <LangToggle />
          {!isBriefing && (
            <Link to="/briefing" className="hidden sm:block text-[13px] font-medium text-muted-foreground hover:text-foreground transition-colors" data-testid="nav-briefing-link">
              {t.header.requestBriefing}
            </Link>
          )}
          <Link to="/login">
            <Button variant="ghost" size="sm" className="text-[13px] text-muted-foreground hover:text-foreground gap-1.5 h-8 px-3" data-testid="nav-login-btn">
              <LogIn className="w-3.5 h-3.5" />
              {t.header.signIn}
            </Button>
          </Link>
          <Link to="/briefing" className="hidden sm:block">
            <Button size="sm" className="bg-primary hover:bg-primary/90 text-[13px] font-medium h-8 px-4 rounded-full" data-testid="nav-cta-btn">
              {t.header.getStarted}
              <ArrowRight className="w-3.5 h-3.5 ml-1" />
            </Button>
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default MarketingHeader;
